import { FormControl, FormControlProps, InputLabel, TextField } from '@mui/material';
import { useField, useFormikContext } from 'formik';

type ChangeValueCallback = { callback(value: unknown, previousValue: unknown): void }['callback'];

export default function FormField({
  Field = TextField,
  name,
  fieldProps,
  inputLabel,
  continuousSync = true,
  children,
  hideInputLabel,
  useValue,
  onChangeValue,
  ...controlProps
}: {
  Field?: React.ElementType;
  fieldProps: object;
  inputLabel?: string;
  name: string;
  continuousSync?: boolean;
  target?: '';
  hideInputLabel?: boolean;
  useValue?: boolean;
  onChangeValue?: ChangeValueCallback;
} & FormControlProps) {
  const { handleSubmit } = useFormikContext();
  const [field, props, helpers] = useField(name);
  const InputField = Field;

  // some events pass their value as the second argument,
  // others as the event target value
  const handleChange = (event: React.ChangeEvent<HTMLFormElement>, value: unknown) => {
    const newValue = useValue ? value : event?.target?.value || value;

    // TODO: Refactor
    helpers.setValue(newValue, false);

    if (continuousSync) {
      // formik doesn't update the form values immediately,
      // so we need to wait for the next tick
      setTimeout(() => {
        handleSubmit(event);
      }, 0);
    }

    // use a different on Change so
    onChangeValue?.(newValue, field.value);
  };

  return (
    <FormControl {...controlProps}>
      {/* TODO: Refactor */}
      {inputLabel && !hideInputLabel && <InputLabel>{inputLabel}</InputLabel>}
      <InputField
        label={inputLabel}
        {...field}
        {...fieldProps}
        onChange={handleChange}
        error={props.touched && !!props.error}
      >
        {children}
      </InputField>
    </FormControl>
  );
}
